import React, { useState } from "react";
import { StyleSheet, View } from "react-native";
import { RequestLayout, ConfirmLayout } from "./components";
import { useNavigation } from "@react-navigation/native";
import { RootStackScreenProps } from "src/navigation/types";

enum Layout {
  Request,
  Confirm,
}

export const AuthPasswordResetScreen: React.FC = () => {
  const navigation =
    useNavigation<RootStackScreenProps<"PasswordReset">["navigation"]>();
  const [layout, setLayout] = useState<Layout>(Layout.Request);
  return (
    <View style={styles.container}>
      {layout === Layout.Request ? (
        <RequestLayout
          onReset={() => {
            setLayout(Layout.Confirm);
          }}
        />
      ) : null}
      {layout === Layout.Confirm ? (
        <ConfirmLayout onConfirm={() => navigation.goBack()} />
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});
